import React from 'react';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';

// Create a styled version of TextField that overrides disabled styles
const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-root.Mui-disabled': {
    backgroundColor: theme.palette.divider,
  },
  '& .MuiInputBase-input.Mui-disabled': {
    color: `${theme.palette.text.primary} !important`,
    WebkitTextFillColor: `${theme.palette.text.primary} !important`,
    opacity: 0.9,
    fontWeight: 500,
  },
  '& textarea.Mui-disabled': {
    color: `${theme.palette.text.primary} !important`,
    WebkitTextFillColor: `${theme.palette.text.primary} !important`,
    opacity: 0.9,
    fontWeight: 500,
  },
}));

const PlaceholderTextField = ({ value, placeholder, disabled, error, onChange, onBlur, rows }) => {
  return (
    <StyledTextField
      value={value}
      placeholder={placeholder}
      variant="outlined"
      disabled={disabled}
      error={error}
      className="textfieldPaddingJson"
      multiline
      maxRows={rows}
      onChange={onChange}
      onBlur={onBlur}
    />
  );
};

export default PlaceholderTextField;
